import Image from 'next/future/image';
import cn from 'classnames';
import i18n from '@/settings/i18n';
import breadcrumbArrow from '@/public/icons/cart/breadcrumbArrow.svg';

const t = i18n.init();
const breadcrumbListCSS = 'flex items-center px-1 sm:px-2 md:px-4 text-xs';
const breadcrumbTextCSS = 'ml-0 sm:ml-[10px] md:ml-[12px]';
const breadcrumbArrowCSS =
  'flex h-[28px] w-[25px] translate-x-[-8px] justify-end sm:translate-x-[0px] md:translate-x-[10px]';

export default function BreadCrumb() {
  const checkoutNav = [
    { step: 2, label: t`Shipping` },
    { step: 3, label: t`Payment` },
  ];

  return (
    <ul className="mb-4 mt-4 flex w-full list-decimal text-xs text-gray-400 sm:mb-6 sm:text-sm">
      <li
        className={cn(
          'pl-0 font-bold text-gray-700 md:pl-1',
          breadcrumbListCSS,
        )}
      >
        <span className="hidden sm:inline">1</span>
        <span className={breadcrumbTextCSS}>{t`Cart`}</span>
        <span className={cn('opacity-40', breadcrumbArrowCSS)}>
          <Image height={11} width={7} alt="hand" src={breadcrumbArrow} />
        </span>
      </li>
      {checkoutNav.map((navItem, index) => (
        <li className={cn('opacity-40', breadcrumbListCSS)}>
          <span className="hidden sm:inline">{navItem.step}</span>
          <span className={breadcrumbTextCSS}>{navItem.label}</span>

          {index < checkoutNav.length - 1 && (
            <span className={breadcrumbArrowCSS}>
              <Image height={11} width={7} alt="hand" src={breadcrumbArrow} />
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
